import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { TrailerEmbed } from "@/components/TrailerEmbed";
import useDocumentTitle from "@/hooks/useDocumentTitle";

export default function Media() {
  useDocumentTitle("Media");
  const [videos, setVideos] = useState(null);
  useEffect(() => {
    axios.get(`${API}/content/videos`, { params: { limit: 60 } })
      .then(r => setVideos(r.data || []))
      .catch(() => setVideos([]));
  }, []);

  const YT_RE = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;
  const isValid = v => YT_RE.test(v?.trailer_url || v?.url || v?.external_url || "");

  const list = (videos || []).filter(isValid);

  return (
    <div data-testid="media-page">
      <section className="container-wide pt-16 pb-8">
        <div className="font-accent text-[10px]" style={{ color: "var(--gi-gold)" }}>Media</div>
        <h1 className="mt-3 font-heading text-5xl sm:text-6xl leading-[1.02]" style={{ color: "var(--gi-maroon)" }}>Videos &amp; Media</h1>
        <div className="hair-divider my-8 max-w-xs" />
      </section>
      <section className="container-wide pb-24">
        {videos === null && <p className="text-sm" style={{ color: "var(--gi-muted)" }}>Loading…</p>}
        {videos !== null && list.length === 0 && (
          <p className="text-sm" style={{ color: "var(--gi-muted)" }} data-testid="media-empty">No videos are currently published.</p>
        )}
        {list.length > 0 && (
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {list.map(v => (
              <div key={v.id} data-testid={`media-card-${v.slug || v.id}`}>
                <TrailerEmbed url={v.trailer_url || v.url || v.external_url} thumbnail={v.thumbnail_url} title={v.title} />
                <div className="mt-3 font-heading text-lg" style={{ color: "var(--gi-charcoal)" }}>{v.title}</div>
                {v.summary && <p className="mt-1 text-sm" style={{ color: "var(--gi-charcoal-2)" }}>{v.summary}</p>}
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
